import get from 'lodash.get';
import { SelectionType, TextAlignment, Unit } from '@philips-internal/oswald-ui-constants';
import { RenderEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isDefined, isFunction } from '@philips-internal/oswald-ui-utils';
import { DEFAULT_ACTION_COLUMN_WIDTH, DEFAULT_SUPERSCRIPTION_COLUMN_WIDTH, DEFAULT_TABLE_COLUMN_WIDTH, DEFAULT_TREE_GROUP_LABEL_COLUMN_WIDTH } from './table-column/table-column-constants.js';
function getDynamicContent(data, entry = '', type, value, onDynamicContentRender) {
    let content = value;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const defaultFunction = (_) => null;
    let renderFn = defaultFunction;
    const render = (fn) => {
        renderFn = fn;
    };
    if (onDynamicContentRender) {
        onDynamicContentRender(new RenderEvent({ data, entry, render, type }));
    }
    if (renderFn !== defaultFunction && isFunction(renderFn)) {
        content = renderFn(data);
    }
    return content;
}
function getFlexAlignment(alignment) {
    const options = {
        [TextAlignment.CENTER]: 'u-flex-jc-center',
        [TextAlignment.LEFT]: 'u-flex-jc-start',
        [TextAlignment.RIGHT]: 'u-flex-jc-end',
    };
    if (alignment && alignment in options) {
        return options[alignment];
    }
    return options[TextAlignment.CENTER];
}
function getSuperscription(value, superscription = []) {
    return superscription.find((item) => item.value === String(value));
}
function getSurperscriptionColor(entry, superscription = [], rowData) {
    const rowValue = get(rowData, entry);
    const superscriptionItem = superscription?.find(item => item.value == rowValue);
    return superscriptionItem?.color;
}
function findRowByKey(data, key, keyField) {
    return data.find((row) => String(row[keyField]) == key);
}
function getTableAvaliableWidth(tableProps, superscriptionBarColumnNumber = 0, isTree, tableContainerRef) {
    const { selectionType, withActions, withExpandedIndicator } = tableProps;
    let avaliableWidth = tableContainerRef.current?.getBoundingClientRect().width || 0;
    if (selectionType === SelectionType.MULTIPLE) {
        avaliableWidth -= DEFAULT_TABLE_COLUMN_WIDTH;
    }
    if (withActions) {
        avaliableWidth -= DEFAULT_ACTION_COLUMN_WIDTH;
    }
    if (withExpandedIndicator) {
        avaliableWidth -= DEFAULT_TABLE_COLUMN_WIDTH;
    }
    if (isTree) {
        avaliableWidth -= DEFAULT_TREE_GROUP_LABEL_COLUMN_WIDTH;
    }
    avaliableWidth -= superscriptionBarColumnNumber * DEFAULT_SUPERSCRIPTION_COLUMN_WIDTH;
    return avaliableWidth;
}
function getTableColumnWidth(columnWidth, tableProps, superscriptionBarColumnNumber, isTree, tableContainerRef) {
    const widthObj = {
        unit: Unit.PX,
        width: isDefined(columnWidth) ? Number(columnWidth) : 0,
    };
    if (typeof columnWidth !== 'string') {
        return widthObj;
    }
    const splitedColumnWidth = columnWidth.split(/(px|%)/);
    const width = Number(splitedColumnWidth[0]);
    const unit = splitedColumnWidth[1];
    widthObj.unit = unit;
    widthObj.width = width;
    if (unit === Unit.PERCENT) {
        const avaliableWidth = getTableAvaliableWidth(tableProps, superscriptionBarColumnNumber, isTree, tableContainerRef);
        widthObj.width = Math.floor((width / 100) * avaliableWidth);
    }
    return widthObj;
}
export { getDynamicContent, getFlexAlignment, getSuperscription, getSurperscriptionColor, getTableAvaliableWidth, getTableColumnWidth, findRowByKey, };
//# sourceMappingURL=table-utils.js.map